export default (request) => ({
  getHoldingsList: (filters, options = {}) => request({
    method: 'get',
    url: '/portfolios/holdings',
    params: filters,
    ...options,
  }),

  getHoldingDetails: (houseFundId, filters, options = {}) => request({
    method: 'get',
    url: `/portfolios/holdings/${houseFundId}`,
    params: filters,
    ...options,
  }),
});
